import { forwardRef } from "react";
import type { LucideProps } from "lucide-react";

/**
 * The WhatsApp glyph, taken from the website draft.
 *
 * lucide dropped its brand icons, so every wa.me button on the public site was
 * reaching for `MessageCircle` — a generic speech bubble that gives the visitor
 * no clue which app is about to open.
 *
 * It takes lucide's own props and forwards a ref so it is interchangeable with
 * a lucide icon wherever one is stored in a data table (`Contact`'s contact
 * ways, for one) rather than written inline.
 */
export const WhatsAppIcon = forwardRef<SVGSVGElement, LucideProps>(
  function WhatsAppIcon({ className, size, ...props }, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        className={className}
        {...props}
        // The glyph is a filled shape; lucide's stroke props would outline it.
        stroke="none"
        strokeWidth={undefined}
      >
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.97L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2Zm0 18.02c-1.5 0-2.97-.4-4.25-1.16l-.3-.18-3.12.82.83-3.04-.2-.31a8.07 8.07 0 0 1-1.24-4.24c0-4.47 3.64-8.1 8.1-8.1 4.47 0 8.1 3.63 8.1 8.1 0 4.46-3.63 8.1-8.1 8.1Zm4.44-6.06c-.24-.12-1.44-.71-1.66-.79-.22-.08-.39-.12-.55.12-.16.25-.63.79-.77.95-.14.16-.28.18-.52.06a6.6 6.6 0 0 1-1.95-1.2 7.3 7.3 0 0 1-1.35-1.68c-.14-.25-.02-.38.1-.51.12-.13.26-.3.39-.46.13-.16.16-.28.24-.46.08-.18.04-.34-.02-.46-.06-.12-.55-1.32-.75-1.8-.2-.48-.4-.42-.55-.42h-.47c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2 0 1.18.86 2.32.98 2.48.12.16 1.68 2.66 4.08 3.63 2.4.97 2.4.65 2.83.61.43-.04 1.4-.57 1.6-1.13.2-.55.2-1.02.14-1.12-.06-.1-.22-.16-.46-.28Z" />
      </svg>
    );
  }
);
